module.exports = "img/NODLOGO.025d5c.jpg";